import React from "react";
import { Box, Checkbox, Grid, GridItem, Text3, TextLink } from "@telefonica/mistica";

export interface CheckBoxTermsContractProps {
	firstText: string;
	linkText: string;
	hrefPath?: string;
	linkExternal?: string;
	restText?: string;
	name: string;
	newTab?: boolean;
	onValue(value: boolean): void;
	onClickLink?(): void;
}

export const CheckBoxTermsContract: React.FC<CheckBoxTermsContractProps> = ({
	firstText,
	linkText,
	hrefPath,
	linkExternal,
	restText,
	name,
	newTab = true,
	onValue,
	onClickLink,
}) => {
	const [checked, setChecked] = React.useState(false);

	const handleOnClickLink = (): Window | null | void => {
		if (onClickLink) {
			return onClickLink();
		}

		if (linkExternal) {
			return window.open(linkExternal, "_blank");
		}

		return newTab ? window.open(`/fgts${hrefPath}`, "_blank") : window.open(`/fgts${hrefPath}`, "_self");
	};

	return (
		<Box>
			<Grid rows={1} columns={10}>
				<GridItem columnStart={1} columnSpan={1}>
					<Checkbox
						name={name}
						checked={checked}
						onChange={() => {
							setChecked(!checked);
							onValue(!checked);
						}}
						dataAttributes={{ "id-checkbox": "id-checkbox"}}
					/>
				</GridItem>
				<GridItem columnStart={2} columnSpan={9}>
					<Text3 regular>
						{firstText}
						{linkExternal ? (
							<a className="links-a" onClick={handleOnClickLink} rel="noreferrer">{` ${linkText} `}</a>
						) : (
							<TextLink
								onPress={(): void => {
									handleOnClickLink();
								}}
							>{` ${linkText} `}</TextLink>
						)}
						{restText}
					</Text3>
				</GridItem>

			</Grid>
		</Box>
	);
};
